module.exports = __webpack_public_path__ + "images/mdj/members/resume/common/profile-image-0898348b48c15e555f0ab78938dc1bf1.svg";